import { useQuery } from '@tanstack/react-query'

import { ValidarSimulacaoParaProposta } from '@/features/simulador/services/validar-simulacao-para-proposta.service'
import { simulacaoKeys } from '@/features/simulador/utils/queries'

export const useValidarSimulacaoParaProposta = (simulacaoId: string) => {
  return useQuery({
    queryKey: simulacaoKeys.validarSimulacaoParaProposta(simulacaoId),
    queryFn: async () => new ValidarSimulacaoParaProposta().execute(simulacaoId).then((res) => res.data),
    enabled: false,
  })
}
